import { ConfigProvider } from "antd";

import { AdminSettingsPage } from "@av/apps/common-apps/platform/pages/admin-settings/AdminSettingsPage";
import type { PlatformAppEntry } from "@av/apps/common-apps/platform/services/apps/types";
import { platformTheme } from "../config/antdPlatformTheme";

type PlatformProps = {
  apps: PlatformAppEntry[];
};

export function Platform({ apps }: PlatformProps) {
  return (
    <ConfigProvider theme={platformTheme}>
      <AdminSettingsPage apps={apps} />
    </ConfigProvider>
  );
}
